import { mapState, mapGetters, mapActions } from 'vuex'

// can('loto.read'): the auth module's module-permission check
// (src/utils/permissions.js). Never undefined, unlike a mapped getter, so a
// template can call it even against a store without the auth module (a unit
// test's bare store): there it allows nothing, as the role getters read false.
const denyAll = () => false
function can() {
  return (this.$store && this.$store.getters['auth/can']) || denyAll
}

export const authComputed = {
  ...mapState('auth', {
    currentUser: (state) => state.currentUser,
    loginUser: (state) => state.loginUser,
  }),
  // Role predicates all come from the auth module (src/utils/roles.js explains
  // why they aren't re-implemented per component).
  ...mapGetters('auth', [
    'loggedIn',
    'email',
    'isAdmin',
    'isAdminOrAgent',
    'isDeveloper',
  ]),
  can,
}

export const authMethods = mapActions('auth', [
  'logIn',
  'logOut',
  'saveLoginUserDetails',
  'newPasswordChallenge',
  'validate',
])
// ])

export const userComputed = {
  ...mapGetters('users', ['firstName', 'lastName', 'phoneNumber', 'id']),
  ...mapGetters('auth', [
    'email',
    'isAdmin',
    'isAdminOrAgent',
    'isDeveloper',
    'roles',
    'id',
    'company',
    'title',
  ]),
  can,
}

export const messagesComputed = mapGetters('messages', ['messages'])

export const messagesMethods = mapActions('messages', ['setNewMessage'])

export const chatComputed = mapGetters('chat', [
  'isOpen',
  'messages',
  'isLoading',
  'isAvailable',
])

export const chatMethods = mapActions('chat', [
  'openPanel',
  'closePanel',
  'endChat',
  'setScopedLocation',
  'askQuestion',
  'askFromBar',
  'setAvailable',
])
